import React, { useState,useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

function Login() {
    const [mobilenumber, setMobilenumber] = useState('');
    const navigate = useNavigate();
    const [isInvalidMobile, setIsInvalidMobile] = useState(false);
    const Login = process.env.REACT_APP_FORE_APILINK + '/user/visitor-admin-login';
    const [message, setMessage] = useState();
    const [error, setError] = useState('');

useEffect(() => {
}, [navigate]);

   
    
    const handleOTP = async () => {
      if (mobilenumber.length === 10) {
        setError('');
        setMessage('');
        
        try {
          const res = await fetch(Login, {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({ mobile_number: mobilenumber }),
          });
          console.log(mobilenumber);
    
          const responseData = await res.json();
          console.log(responseData);
          
          if (res.ok) {
            setMessage(responseData.message);
            // Navigate to OTP page only if login was successful
            navigate('/visitor/otp', { state: { mobileNumber: mobilenumber } });
          } else {
            // Handle different error cases
            if (res.status === 404) {
              // User not registered
              sessionStorage.setItem('unregisteredMobile', mobilenumber);
              setError(responseData.message || 'User not registered. Please register.');
            } else {
              setError(responseData.message || 'Login failed. Please try again.');
            }
          }
        } catch (error) {
          console.error('Error:', error);
          setError('An error occurred. Please try again later.');
          clearStorageAndRedirectToHome();
        }
      } else {
        setIsInvalidMobile(true);
      }
    };
    
    function clearStorageAndRedirectToHome() {
      window.location.href = '/visitor';
    }
    
     useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const handleChange = (e) => {
        const value = e.target.value;
        const numericValue = value.replace(/\D/g, '');
        const truncatedValue = numericValue.slice(0, 10);
        setMobilenumber(truncatedValue);
        setIsInvalidMobile(false);
        setError(''); // Clear error when user types
    };




    return (
        <div className="w-full min-h-screen flex justify-center items-center bg-white">
            <div className="w-full max-w-md px-6 py-10 flex flex-col items-center justify-center">
                {/* Logo and welcome text */}
                <div className="flex flex-col items-center mb-8">
                    <img src="/BB.png" alt="Logo" className="h-20 w-20 mb-6" />
                    <h2 className="text-xl  text-[#00000] text-center">Welcome to Brickbucket</h2>
                    <p className="text-[#A8A1A1] mt-1 text-center text-md font-semibold">Build Together. Build Strong</p>
                </div>
                
                {/* Login card - centered with fixed width */}
                <div className="bg-white rounded-md shadow-sm border border-[#C20C0C] overflow-hidden w-full max-w-sm mx-auto  flex flex-col justify-between">
    <div className="px-4 py-5">
        <h3 className="text-lg font-semibold text-[#00000] ml-1">Login with your Mobile Number</h3>
    </div>
    
    <div className="px-5 pb-7 flex-grow flex flex-col justify-center">
        {/* Mobile input field */}
        <div className="mb-4">
            <label htmlFor="mobile" className="block text-md font-medium text-gray-700 mb-2">
                Mobile Number
            </label>
       <div className="relative">
   
    <div className="absolute inset-y-0 left-0 flex items-center pl-3 pr-3 pointer-events-none bg-[#F0EBEB] rounded-l-md border-l border-t border-b border-[#C20C0C] overflow-hidden">
    <span className="text-gray-600 font-medium">+91</span>
</div>

    <input
    id="mobile"
    type="tel"
    inputMode="numeric"
    pattern="[0-9]*"
    placeholder=""
    className={`w-full rounded-md py-3 pl-16 pr-3 border bg-white text-black ${
        isInvalidMobile ? 'border-[#C20C0C] focus:ring-[#C20C0C]' : 'border-[#C20C0C] focus:ring-[#C20C0C]'
    } focus:border-[#C20C0C] focus:outline-none focus:ring-0 autofill:!bg-white autofill:!text-black autofill:shadow-[inset_0_0_0px_1000px_white]`}
    value={mobilenumber}
    onChange={handleChange}
/>


</div>


            {isInvalidMobile && (
                <p className="text-[#D93025] font-semibold text-sm mt-1">Mobile number must be 10 digits</p>
            )}
        </div>
        
        {/* Error message display */}
        {error && (
            <div className="text-center text-sm mb-4 text-[#D93025] font-medium">{error}</div>
        )}
        
        {/* Success message display */}
        {message && (
            <div className="text-center text-sm mb-4 text-green-600 font-medium">{message}</div>
        )}
        
        {/* Send OTP button */}
        <div className="mt-1">
            <button
                className="w-full bg-[#F84C5C] text-white py-3 px-4 text-lg font-semibold rounded-md font-medium hover:[#D93025]"
                onClick={handleOTP}
            >
                Send OTP
            </button>
        </div>
    </div>
</div>
            </div>
        </div>
    );

}
export default Login;
